var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50586 11.1332L0.798753 10.4261L0.505859 10.719V11.1332H1.50586ZM11.1059 1.5332L11.813 0.826096C11.4224 0.435572 10.7893 0.435572 10.3988 0.826096L11.1059 1.5332ZM16.4392 6.86654L17.1463 7.57364C17.3338 7.38611 17.4392 7.13175 17.4392 6.86654C17.4392 6.60132 17.3338 6.34697 17.1463 6.15943L16.4392 6.86654ZM6.83919 16.4665V17.4665H7.25341L7.5463 17.1736L6.83919 16.4665ZM1.50586 16.4665H0.505859C0.505859 17.0188 0.953575 17.4665 1.50586 17.4665L1.50586 16.4665ZM2.21297 11.8403L11.813 2.24031L10.3988 0.826096L0.798753 10.4261L2.21297 11.8403ZM10.3988 2.24031L15.7321 7.57364L17.1463 6.15943L11.813 0.826096L10.3988 2.24031ZM15.7321 6.15943L6.13209 15.7594L7.5463 17.1736L17.1463 7.57364L15.7321 6.15943ZM6.83919 15.4665H1.50586V17.4665H6.83919V15.4665ZM2.50586 16.4665V11.1332H0.505859V16.4665H2.50586ZM7.19875 5.44031L12.5321 10.7736L13.9463 9.35943L8.61297 4.0261L7.19875 5.44031ZM9.50586 17.4665H16.9725V15.4665H9.50586V17.4665Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.5528148f529eecad5ca01fc9597913bf.svg";
export { ForwardRef as ReactComponent };